import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";

import { AutoLogout, PDFWrapper } from "commons";
import { isPrintMode } from "commons/src/QueryParameter";
import { isInsideGoReactNativeApp } from "commons/src/helpers/ReactNativeAppHelpers";
import { hydrateState } from "commons/src/reducers/indexActions";

import { autoLogInIfAlreadyLoggedIn, logout } from "./DataOperations";
import { GoErrorLogger } from "./GoErrorLogger";
import { NuRouter } from "./NuRouter";
import { ThemeWrapper } from "./ThemeWrapper";

import "../css.css";

function AppComponent({
    currentUser,
    printingState,
    isFatal,
    hydrateState,
    clientId,
    termsAccepted,
    theme,
    redirect
}) {
    useEffect(() => {
        !isFatal && !isPrintMode() && autoLogInIfAlreadyLoggedIn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(
        () => {
            if (isPrintMode() && printingState && !currentUser) {
                hydrateState(printingState);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [currentUser, printingState]
    );

    const loggedIn = !!(clientId && termsAccepted && theme.isThemeReady);

    return (
        <ThemeWrapper theme={theme.selectedTheme}>
            <Container>
                <NuRouter redirect={redirect} />
                {loggedIn && !isInsideGoReactNativeApp() ? <AutoLogout logout={logout} /> : null}
            </Container>
        </ThemeWrapper>
    );
}

const Container = styled.div`
    min-height: 100vh;
    -webkit-overflow-scrolling: touch;
`;

const mapStateToProps = state => ({
    clientId: state.user.id,
    currentUser: state.user.currentUser,
    redirect: state.navigation.path,
    termsAccepted: state.user.termsAccepted,
    theme: state.theme,
    isFatal: state.applicationContext.isFatal
});

const mapDispatchToProps = dispatch => ({
    hydrateState: newState => dispatch(hydrateState(newState))
});

AppComponent.propTypes = {
    children: PropTypes.object,
    currentUser: PropTypes.object,
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isFatal: PropTypes.bool,
    redirect: PropTypes.string,
    termsAccepted: PropTypes.bool,
    theme: PropTypes.shape({
        selectedTheme: PropTypes.object,
        isThemeReady: PropTypes.bool
    }),
    hydrateState: PropTypes.func,
    printingState: PropTypes.object
};

export const App = GoErrorLogger(
    PDFWrapper(connect(mapStateToProps, mapDispatchToProps)(AppComponent), "client-portal")
);
